import { EmpMasterPage } from '@/features/emp-master/EmpMasterPage';

export function PeopleMasterPage() {
  return (
    <section className="people-master-page">
      <div className="people-master-page__viewport">
        <EmpMasterPage />
      </div>
    </section>
  );
}
